var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsitesFormsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "websites-forms-icon_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".websites-forms-icon_svg__cls-1,.websites-forms-icon_svg__cls-2{fill:#e84b0f;stroke-miterlimit:10;stroke:#010101;stroke-width:2px}.websites-forms-icon_svg__cls-2{fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.68 20.77c1.16 11.7-8.59 21.45-20.29 20.29-8.66-.86-15.66-7.86-16.52-16.52-1.16-11.7 8.59-21.45 20.29-20.29 8.66.86 15.66 7.86 16.52 16.52z",
    fill: "#f9d8cd",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "websites-forms-icon_svg__cls-2",
    d: "M9.92 13.91h32.46c1 0 1.82.82 1.82 1.82V64.8c0 .52-.39.91-.91.91H9.01c-.52 0-.91-.39-.91-.91V15.73c0-1 .82-1.82 1.82-1.82z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "websites-forms-icon_svg__cls-1",
    d: "M44.2 19.77H8.09v-4.04c0-1 .82-1.82 1.82-1.82h32.46c1 0 1.82.82 1.82 1.82v4.04z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "websites-forms-icon_svg__cls-2",
    d: "M12.04 22.81h28.21c.52 0 .91.39.91.91v3.7c0 .52-.39.91-.91.91H12.04c-.52 0-.91-.39-.91-.91v-3.7c0-.52.43-.91.91-.91zM12.04 31.37h28.21c.52 0 .91.39.91.91v3.7c0 .52-.39.91-.91.91H12.04c-.52 0-.91-.39-.91-.91v-3.7c0-.52.43-.91.91-.91zM12.04 39.93h28.21c.52 0 .91.39.91.91v12.27c0 .52-.39.91-.91.91H12.04c-.52 0-.91-.39-.91-.91V40.84c0-.52.43-.91.91-.91z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "websites-forms-icon_svg__cls-1",
    d: "M12.04 57.06h28.21c.52 0 .91.39.91.91v3.7c0 .52-.39.91-.91.91H12.04c-.52 0-.91-.39-.91-.91v-3.7c0-.52.43-.91.91-.91z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#010101",
    strokeWidth: 2,
    d: "M38.64 25.57h0"
  })));
}
export default SvgWebsitesFormsIcon;